import React, { useContext, useState } from 'react';
import GlobalContext from '../../contexts/GlobalContext';
import Input from '../Input/Input';
import ThankYouPopupDoNotSell from './ThankYouPopupDoNotSell';
import Form from './Form';

type DoNotSellProps = {
  setClosePopup: Function;
};

const DoNotSell = (props: DoNotSellProps): JSX.Element => {
  const { globalContext } = useContext(GlobalContext);
  const thankyouPopUpText = globalContext.i18n.getText(
    'thanks_text_do_not_sell'
  );
  const captchaNote = globalContext.i18n.getText('captcha_note');
  const regulatoryUpdatesPara = globalContext.i18n.getText(
    'regulatory_updates_para_do_not_sell'
  );
  const regulatoryUpdatesHeading = globalContext.i18n.getText(
    'regulatory_updates_heading_do_not_sell'
  );

  const [successPopup, setSuccessPopUp] = useState(false);
  const closePopupWithOkayButton = () => {
    props.setClosePopup(false);
    globalContext.gtm.pushVersionedEvent(
      '2.11',
      'DoNotSellInformation',
      'ClickOkayButton',
      '',
      null,
      true
    );
  };

  const closePopUpWithCross = () => {
    props.setClosePopup(false);
    globalContext.gtm.pushVersionedEvent(
      '2.11',
      'DoNotSellInformation',
      'ClickCloseIcon',
      '',
      null,
      true
    );
  };

  return (
    <div className="regulatory-updates-modal__inner">
      <button
        className="close-button"
        id="close_dont-sell_info_popUp"
        data-close=""
        onClick={closePopUpWithCross}
        aria-label="Close modal"
        type="button">
        <span aria-hidden="true" className="close-button__icon">
          ×
        </span>
      </button>
      {!successPopup && (
        <div>
          <div className="regulatory-updates-modal__header">
            <h2 className="regulatory-updates__heading">
              {regulatoryUpdatesHeading}
            </h2>

            <p className="regulatory-updates__para">{regulatoryUpdatesPara}</p>
          </div>

          <form
            method="post"
            className="form-wrapper"
            action=""
            acceptCharset="UTF-8">
            <Input type="hidden" value="dont_sell_form" name="form_type" />
            <Input type="hidden" name="utf8" value="✓" />
            <Input
              type="hidden"
              className="validate-form-info"
              data-msg="loginError"
            />
            <Form setSuccessPopUp={setSuccessPopUp} />
            <div className="captcha-note">
              {captchaNote}
              <a
                // eslint-disable-next-line react/jsx-no-target-blank, react/jsx-no-comment-textnodes
                href="https://policies.google.com/privacy"
                target="_blank"
                className="captcha-note__link">
                Privacy Policy{' '}
              </a>
              and
              {/* eslint-disable-next-line react/jsx-no-target-blank, react/jsx-no-comment-textnodes */}
              <a
                href="https://policies.google.com/terms"
                target="_blank"
                className="captcha-note__link">
                {' '}
                Terms of Service
              </a>{' '}
              apply.
            </div>
          </form>
        </div>
      )}
      {successPopup && (
        <ThankYouPopupDoNotSell
          message={thankyouPopUpText}
          closePopUp={closePopupWithOkayButton}
        />
      )}
    </div>
  );
};

export default DoNotSell;
